import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c(VSelect,{attrs:{"label":_vm.field.description,"items":_vm.values,"item-value":"v","item-text":"d","cache-items":"","clearable":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }